import { Text, VSpacer } from '@/components/DesignSystem';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LoginTelephoneInput } from "@/pages/Auth/LoginTelephoneInput";
import { LoginEmailAndTelephoneInput } from "@/pages/Auth/LoginEmailAndTelephoneInput";

interface LoginFormProps {
  onConfirmSuccess: ({ lastFour, telephone }: { lastFour: string, telephone: string }) => void,
  telephoneOnly?: boolean,
}

export const LoginForm = ({
  onConfirmSuccess,
  telephoneOnly,
}: LoginFormProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <>
      <Text category="headline-large">{t($ => $.auth.login.title)}</Text>
      <VSpacer size="3" />
      <Text category="body-large" sx={{ color: theme.palette.text.secondary }} textAlign="center">
        {telephoneOnly
          ? t($ => $.auth.login.instructionPhone)
          : t($ => $.auth.login.instructionPhoneOrEmail)
        }
      </Text>
      <VSpacer size="7" />
      {telephoneOnly
        ? <LoginTelephoneInput onConfirmSuccess={onConfirmSuccess} />
        : <LoginEmailAndTelephoneInput onConfirmSuccess={onConfirmSuccess} />
      }
    </>
  );
};
